import { LoggedInUserType } from "../types/LoggedInUserType";

export default function getUserTypeText(userType: LoggedInUserType) {
    switch (userType) {
        case LoggedInUserType.DOCUMENT_COLLECTOR:
            return "Vessel Contact";
        case LoggedInUserType.IDWAL_ADMIN:
            return "Idwal";
        case LoggedInUserType.IDWAL_SURVEYOR:
            return "Surveyor";
        default:
            return "Unknown";
    }
}

export function userIsDocCollector(state: any) {
    return state.portal.userType === LoggedInUserType.DOCUMENT_COLLECTOR;
}